import { Column, Table } from '@tanstack/react-table';

export function columnIsVisible<T extends object = {}>(column: Column<T, unknown>, table: Table<T>) {
  return table.getState().columnVisibility?.[column.id] ?? true;
}

export function allParentColumnsVisible<T extends object = {}>(column: Column<T, unknown>, table: Table<T>): boolean {
  if (!column.parent || column.depth === 0) {
    return columnIsVisible(column, table);
  }

  const isParentVisible = columnIsVisible(column.parent, table);
  if (!isParentVisible) {
    return false;
  }

  return column.depth > 1 ? allParentColumnsVisible(column.parent, table) : isParentVisible;
}
